import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import React, { useContext, useEffect } from 'react'
import MemberSongwriterHandler from '@Components/Navigations/MemberSongwriterHandler'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router'

const MemberSongwriterSwitcher = () => {
    const { uiStore, userStore, popupStore, rightsholderSearchStore, songwriterSearchStore } = useContext(StoresContext)
    const rightsHoldersData = rightsholderSearchStore.rightsholders
    const songwriterData = songwriterSearchStore.songwriters
    const navigate = useNavigate()

    useEffect(() => () => popupStore.setRightsholderTrayState(false), [])

    const onClick = () => {
        if (uiStore.homePageState === 'member') {
            popupStore.setRightsholderTrayState(!popupStore.rightsholderTrayState)
        } else {
            navigate(Navigation.home.root())
        }
    }

    if ((!rightsHoldersData?.content.length && !songwriterData?.content.length) || userStore.isInternal) {
        return null
    }

    const hasBoth = !!rightsHoldersData?.totalElements && !!songwriterData?.totalElements

    const count = uiStore.homePageState === 'member' ? rightsHoldersData?.totalElements : songwriterData?.totalElements
    const link =
        uiStore.homePageState === 'member'
            ? Navigation.rightholder.summary(rightsHoldersData.content[0].ipId)
            : Navigation.songwriter.catalog.root(songwriterData.content[0].id)

    return hasBoth ? (
        <>
            <MemberSongwriterHandler
                count={rightsHoldersData?.totalElements}
                type="member"
                firstNavLink={Navigation.rightholder.summary(rightsHoldersData.content[0].ipId)}
                onClick={() => {
                    uiStore.setHomePageState('member')
                    navigate(Navigation.home.root())
                }}
            />
            <MemberSongwriterHandler
                count={songwriterData?.totalElements}
                type="songwriter"
                firstNavLink={Navigation.songwriter.catalog.root(songwriterData.content[0].id)}
                onClick={() => {
                    uiStore.setHomePageState('songwriter')
                    navigate(Navigation.home.root())
                }}
            />
        </>
    ) : (
        <MemberSongwriterHandler count={count} type={uiStore.homePageState} firstNavLink={link} onClick={onClick} />
    )
}

export default observer(MemberSongwriterSwitcher)
